<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <header><h2>Logout</h2></header>

      @if (isLoading) {
        <div >
          <div class="spinner-container">
            <div class="spinner"></div>
          </div>
          <h5>Logging out...</h5>
        </div>
      }

      @if (!isLoading) {
        <div>
          <div class="classlist-container">
            <h5>Redirecting...</h5>
          </div>
        </div>
      }
    </div>
  </div>
</section>




